import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "desktop-error-outer" }
const _hoisted_2 = { class: "desktop-error-logo-container" }
const _hoisted_3 = { class: "desktop-error-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-top ion-text-center" }, " Ez egy telefonos applikáció. Kérlek, mobiltelefonon nyisd meg a weboldalt. ", -1)
const _hoisted_5 = { class: "__app-flex" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "__app-flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("hamarosan")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Itt lesznek láthatók a híreink az applikációról. Látogass vissza ide és ne maradj le semmiről! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_PartyModal = _resolveComponent("PartyModal")!
  const _component_PartySearch = _resolveComponent("PartySearch")!
  const _component_TownsModal = _resolveComponent("TownsModal")!
  const _component_TrendingSearchModal = _resolveComponent("TrendingSearchModal")!
  const _component_FriendsModal = _resolveComponent("FriendsModal")!
  const _component_ProfileModal = _resolveComponent("ProfileModal")!
  const _component_FriendSearchModal = _resolveComponent("FriendSearchModal")!
  const _component_PlaceModal = _resolveComponent("PlaceModal")!
  const _component_PlaceSearch = _resolveComponent("PlaceSearch")!
  const _component_PartyJoinModal = _resolveComponent("PartyJoinModal")!
  const _component_InviteFriendsModal = _resolveComponent("InviteFriendsModal")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      (!_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_ion_router_outlet, {
            key: 0,
            ref: "mainRouterOutlet"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_PartyModal, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_PartySearch, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_TownsModal, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_TrendingSearchModal, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_FriendsModal, { key: 5 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_ProfileModal, { key: 6 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_FriendSearchModal, { key: 7 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_PlaceModal, { key: 8 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_PlaceSearch, { key: 9 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_PartyJoinModal, { key: 10 }))
        : _createCommentVNode("", true),
      (_ctx.ready && !_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_InviteFriendsModal, { key: 11 }))
        : _createCommentVNode("", true),
      (_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 12,
            fullscreen: "",
            class: "ion-padding"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ion_img, {
                    src: './assets/icon/icon.png',
                    class: "__app-img desktop-logo"
                  }, null, 8, ["src"]),
                  _createVNode(_component_ion_img, {
                    src: './assets/image/logo-text.png',
                    class: "__app-img desktop-logo"
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_img, {
                    src: './assets/image/qr-code-white.png',
                    class: "__app-img"
                  }, null, 8, ["src"]),
                  _hoisted_4
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLocked)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 13,
            fullscreen: "",
            class: "ion-padding"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ion_img, {
                  src: './assets/icon/icon.png',
                  class: "__app-img"
                }, null, 8, ["src"]),
                _createVNode(_component_ion_img, {
                  src: './assets/image/logo-slogan.png',
                  class: "__app-img ion-margin-top"
                }, null, 8, ["src"])
              ]),
              _createVNode(_component_ion_slides, {
                options: {
                    preloadImages: true,
                    lazy: false,
                },
                pager: true,
                ref: "slides"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_slide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.mapUrl,
                        class: "__preview-img",
                        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadImages && _ctx.loadImages(...args)))
                      }, null, 40, _hoisted_6)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_slide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.activitiesUrl,
                        class: "__preview-img",
                        onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.progress++))
                      }, null, 40, _hoisted_7)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_slide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.friendsUrl,
                        class: "__preview-img",
                        onLoad: _cache[2] || (_cache[2] = ($event: any) => (_ctx.progress++))
                      }, null, 40, _hoisted_8)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_slide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.searchUrl,
                        class: "__preview-img",
                        onLoad: _cache[3] || (_cache[3] = ($event: any) => (_ctx.progress++))
                      }, null, 40, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ion_card, { class: "__twhite __app-welcome" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, { onClick: _ctx.clickInput }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              disabled: _ctx.inputDisabled,
                              class: "__forcewhite",
                              placeholder: "Fejlesztés alatt",
                              type: "text",
                              modelValue: _ctx.password,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, { onClick: _ctx.checkPassword }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}